var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIwgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "-2 -2 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3002_12902)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white",
    stroke: "#002F1B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.2,
    width: 16,
    height: 7.58,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3002_12902",
    x: -1,
    y: -1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3002_12902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3002_12902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3002_12902",
    transform: "translate(-0.0328948) scale(0.00986842 0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3002_12902",
    width: 108,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAAwCAYAAAD0Kp9BAAALAklEQVR4Ac1cCYwdRxH95r5BCMR9XwqIO9xCBJA4AgQIrIi9U7PrBC0RZsHrnerf1WvCBxmJIAgECJeEAAkQ4Yo5xSGMOQQhKCGCxBhIjCFBJPGBrxDfi2r+9Lhnpq+Z/fvXK62mp6fr9auqObqrq3+vZ/xBlt17GvGha4kePDE3d0/j0pKKyUbxlIQwA8q+DYQ3AuFhIFws/g8A4Z9Swq+llL3jPCEeHttZ0u8/E6SglPC7QLgTCI8auHuBxDUg8YspiakLBnMPjMUdcbtVaxbmHzOpxCtThecDZeuB8KJUiUFeVrgulfi2yQXxwnRh7hHBvhPC3wDhv4DwuKGsNiYbYAco/EYQqNZgMBjcKZG4GgivsuBqfNvxJBD+NJH4mhpkfnrWYHAXoOwCILyuJe7xROF3UspeZMMdZd35QtwXFE6Dwm+Bwl0tee4Gid/jG5wd3eAVCbazIeipYKMkhH+MxLY5TddtmdqIT9Bd8V0KhDeMAPeKRK1/mMYd1RH6/UcnhJ8FwttHwFHb4LeTcv55JcdI4FiHrUoIleNp1QTaHg8lEt8OJD4WyTUWf09C4pzSEEsozAwG9wKJl9ReybE8gu0Slb2upBdphKDDJiYm7gwSvxCJFyQ5JpwTqRTvLI3RocB3PxD+Yzn5rtmITyqpRXYUdBiQ+Hwk1unirJJHQmJtaZAWBR4sAOEdy6z3bb1eb1VJK7Izr8NA4VwkjjbSoeJbxIOdUSq8Dyj7e0r4byA80oLTiSnCl5RGiSgkUkwC4YkWfWjdWx159FyhE9mh02GT/f7TI43zFx7GprThySYBHk1OK3wWD3WB8KZIPqbSVycSZ/iDb+LyaJKHyonMPgyEuyNwd04OZu9nYrjKoPqvHoezmDM/xRUeEYqwcZwOA8JfBDBuT6R4Fxuw0rHlZHZ29u6JzN4HhMcCmMxpL08bKq8LCyZXTQwG90klfjwC82IHRFnNNwYQ7onAMm+qruX9jflwZMdWh/FcySuvcNeUnH9uqW1kISX8oBeX8AZzuB8J2yu+Ob6b4Y61Cxse5cPjOWKAm8s5PB+VQPgyniBP9Pv3538OFKQqe0Yi8S2gxKZiXpwHAFLKPtngEtm5w2HiRx75o+mCeH6jw4gKILzeg7u/MmqKwDObFJNul1EXEyU+YLY3y0UgwClr48wO4FeziRMqsyNBZeetkfLxjba2Tix1DYdxCMv3Hk+k6Dc6i6iABXGmpf/SSKnK1kTAeJvkEYhTobESu+h3J39X6wDDCEvLSbsSm3i6U8da0rnPOMa1hsMShalxva70PycGg7t1IZbK7L0e3KtivlmhfmFj9jjfd3KS5p9axwAS4OFV13+RY5x1jJGcR5JoOAwUfsYje1FXcol0v2a7zpdsXDhe5+LPkZW6TPFtaTrG9qR2iL3W+3Oeu0jX6psOI/xVrU2pTNdvF5MsAtElltnHKON/IMWFJnalLPES02A8FalctzmprMsOrlbqIab8SMuRRJoOk7jdJdv1dVg4zDXh5Rn/yP6Shf6LXfzrk9Xh0lC5HGS9mTRWqrIPjYykDUh3FDg2HeacjGYHbf3E1M3MzNzVw+P6GIzYNoGn5ocmDhBu8fCqOHBayseasiMvRxJpOKwI/1TIFlhHlkLSw2fHUnDrsjw/dPalcLNuX4wOY8NnV2u5ZTs6SZfv5PxV0HCYb64UtXLq0AgI9zk4HeEn0CHWujqV2Zsd/SyCxC9rQJ7UOttVbbTIYTAtt2zHSDI2h33fJZuqLOlKGAj/4MJNZHZWV9y6XCBUVY5yed7n4tOolzhR72fk541Oa3dNcb3hsCLmZ3slct3PuxIFhZ9zcjLu/K74LMfxOSC8zdkP4dkavwgnufSs1PPTqOWW7eghbZJpOIzTAHyybcMxWsGExJs8uMcTKZ+o23Y9Fokwpn5m+TAHizV2orLLPHxMucXV8/MP0nLLdowk03AYRxx47ckpr7JfdyGdL7cT7nfh1ofcbfsonq7/uPHF5SZmQtmXXG3r9aZc2zLfJBxhSdX8azmOmKdF5HNFAZzKwHNbDgfyRLVylzjObQ7rhecn4ty2xLl9QuKjDh4F1+wFXXBZJlUCfdgJ4UtNbCC8wtfeuHbAlGtbBsKtBpbTJ0tyGN8VgcXBHdODwT1akxfiDB/5VOLvusQUi4A150G6DLK1zhUUbva0N3H21WXbnI/FYUwolB7Aa1ttiHPb8BOGHFy9sC1uSuJyn/Fto1Ag/LpPxrh2tC0fs/3YHMZhqECu4DFOIzDJ+crF8kpMrsT+VlnCJM4xjGs+Gbq8xcarzTeMV8xtGDF1Y3MYkwmM7Nggv7etMdUV4ahCmwRUzuStY9jO80xcf77ISc4rsckC4cUBR2uHL4ZWq234um6sDuNOE8Kf+BXL3q3JuY6hAYENnyMWLjxdDyQutcnqOh6667b1Y6pwVrcLHW2v1Dqe63zsDuPlbCD8n1up7GA9s8kkz0FTv7x9oMAxTV+2U5Ho6XvF3uyTTwlf79apyomTjUyd2pTH7jAmF3pCfK8woOzHsYapt7Mmq/R6vWHgNru23t48T/vZG32GnRTikWZ7X5kHNT4s37UVcdjQQOIan1K2XSlA4lyfDBBe6VvY5Fx+3npUN0ii8D0+XN8NZGIFwljlNwwI/9s1QL0iDmMli2UL29aloWISt5sLnDxPC+SmH+MIACxkb/AbX/zSnJtxmIgN6JE5EDvK5OiKB8d02CKnq5nOji2vmMOYIEj8iE9B/pBrRYKvUWPJgvep+XB5tKpxgfATvragcJ1uGzrme73ck+2Kw3hEbN44IWx9fUUdxsNozwInK3gLR0mmB+sfwBm8HsPexLtCtVKc0wGE7kiFwm156vdwAGPuxqwb9cqYaYbut+Bp7hqt41XOOaNMy8YeV9RhTDIi6VIOt41WR1pV5zVjkaEnkp+GwGT3ZGWDXKRFgfCrVW4+3nigTbCAKay4w4bR/HywULn7DKV3A2UHjfN6O2vkISKycrNvQyE7M9JHlWap3PBsD9c6dz6/pU2a+ungsB5PJFsqeUrxBXFmxWLGSctvyilM3rRe2+ViwAaLLQLBus/DvCO1saHB0tNp4TDmFUuk4lgjCcaiWy/f7alwW0UmalAgLrXhxdbxBowuk3sgvDUPaMvsFfx9r/dXhM6cqRGmnktaXql3bDtPlXi52WFMOVH4HBuWWdc6dZp/JWEJT5fuO7Q6EaNfMa+7EUj8FQidi6k2rGV3GCsKhH+2dW6rS1Q+n9L2cR6Lb9mtNgxH3VecYO0urGqx5KJfjSM7jsVh+Q7JqFcWLqYk3hprPyB8v8M5DQO13RLr41CkMUQnl8ZyjGk3FocVK9MxyZh7zCiIz2h8rdgN2XBOQ3GF20JYba8PndY9/tngGHlDj8VhuXEDUQpWICX8dFvDFXFGr9N4C1Nb3Jj2w8GP2NTV+F3kxuawfEto4C6akviqGEOZbUIBXjbKVL//NFNm1GV+3fLvZXVxQFuZsTks3wZq/z0r/XQc6rLEzj88FlDamvE1aqflq+W8ybHTdMMbNdH24RTy7WNzGBso8Pr6WVcjAiFHN04pZpS7Rja6cuEYJafKFb851eVnLE7poXBXKsUPUso2lG8JXm3NE/55+ULhdL4krnAdBzDzpEYhzuiSqmZTmCPkxR1o/ngWJ41eZ9v1aMOw1XFMMpX4t9qkdi9Qdm1ogdKGN8q6fGAkcYK30Oa/FqRwc5FOwXmIW/mnAxPKvgmEn+KoCP9EH/8Imis/5P+uECitH7/uJQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIwgSelected);
export default __webpack_public_path__ + "static/media/pin_iwg_selected.95c5cd4cd21dd428239a055a52dab2d5.svg";
export { ForwardRef as ReactComponent };